
(function () {
  'use strict';

  function getCartDrawer() {
    return document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]');
  }

  function renderCart() {
    fetch('/cart?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function () { 
        var drawer = getCartDrawer();
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (drawer) {
          drawer.classList.add('is-open', 'active', 'open');
          drawer.setAttribute('open', '');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {});
  }

  function addToCart(form) {
    var fd = new FormData(form);
    if (!fd.get('id')) return;
    if (!fd.get('quantity')) fd.set('quantity', '1');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; });
      return res.json();
    }).then(function () {
      renderCart();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form).catch(function (err) {
      console.error('Add to cart failed', err);
      window.location.href = '/cart';
    });
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    addToCart(form).catch(function () {
      window.location.href = '/cart';
    });
  });
})();
